const AuthCard = ({ logo, children }) => (
    <div className="box">
        {children}
    </div>
)

export default AuthCard
